import React from "react";
import {WhatsAppMediaType} from "../../../types/ConversationMessage";
import {BASE_URL} from "../../../contants/network";
import ConversationMediaImage from "./ConversationMediaImage";
import ConversationMediaPDF from "./ConversationMediaPDF";
import ConversationMediaAudio from "./ConversationMediaAudio";

export interface ConversationMessageMediaItemProps {
    contentType: WhatsAppMediaType;
    url: string;
}

interface ConversationMessageMediaProps {
    text: string;
    media?: ConversationMessageMediaItemProps[];
    mediaUrl?: string;
}

const ConversationMessageMediaItem = ({ mediaItem, text }: { mediaItem: ConversationMessageMediaItemProps, text: string }) => {
    if([WhatsAppMediaType.IMAGE_JPEG, WhatsAppMediaType.IMAGE_PNG, WhatsAppMediaType.IMAGE_GIF].includes(mediaItem.contentType)) {
        return <ConversationMediaImage mediaItem={mediaItem} text={text} />
    } else if(mediaItem.contentType === WhatsAppMediaType.APPLICATION_PDF) {
        return <ConversationMediaPDF mediaItem={mediaItem} />;
    } else if([WhatsAppMediaType.AUDIO_AAC, WhatsAppMediaType.AUDIO_AMR, WhatsAppMediaType.AUDIO_OGG, WhatsAppMediaType.AUDIO_MPEG].includes(mediaItem.contentType)) {
        return <ConversationMediaAudio mediaItem={mediaItem} />;
    } else {
        return null;
    }
}

const ConversationMessageMedia = ({ text, media, mediaUrl }: ConversationMessageMediaProps) => {
    return (
        <div className="message-bubble-media-container">
            {media?.map(mediaItem => <ConversationMessageMediaItem key={`media-${mediaItem.url}`} mediaItem={{ contentType: mediaItem.contentType, url: `${BASE_URL}${mediaItem.url}` }} text={text} />)}
            {mediaUrl ? <ConversationMessageMediaItem mediaItem={{ contentType: WhatsAppMediaType.IMAGE_PNG, url: mediaUrl }} text={text} /> : null}
        </div>
    );
}

export default ConversationMessageMedia;